module.exports = __webpack_public_path__ + "static/media/dropbox-social-media-svgrepo-com.c40ee95b.svg";